<template>
  <v-app>
    <v-main>
      <v-container v-if="processing" fill-height grid-list-md text-center ghost>
        <v-row wrap align-center>
          <v-col>
            Extracting data from image...
            <v-progress-linear
              color="light-blue accent-4"
              indeterminate
              rounded
              height="6"
            ></v-progress-linear>
          </v-col>
        </v-row>
      </v-container>
      <v-container v-else>
        <v-row>
          <v-col cols="12">
            <video ref="video" autoplay playsinline class="video"></video>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="text-center">
            <v-btn @click="capturePhoto" color="primary">Capture Photo</v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="mt-16" class="text-center">
            <i
              >For better results, please use the official PDF printout of your
              biometer and include measurements of both eyes.</i
            >
          </v-col>
        </v-row>
      </v-container>
      <v-snackbar
        v-model="snackbar"
        :timeout="snackbarTimeout"
        top
        @timeout="closeSnackbar"
      >
        {{ snackbarMessage }}
        <v-btn color="red" text @click="closeSnackbar">OK</v-btn>
      </v-snackbar>
    </v-main>
  </v-app>
</template>

<style>
.video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.v-snackbar {
  top: 50% !important;
  transform: translateY(-50%);
}
</style>

<script>
export default {
  data() {
    return {
      snackbar: false,
      snackbarMessage: '',
      snackbarTimeout: 6000,
      processing: false,
    }
  },
  mounted() {
    this.startVideo()
  },
  methods: {
    async startVideo() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: { exact: 'environment' } },
        })
        this.$refs.video.srcObject = stream
      } catch (error) {
        this.showError("Sorry we can't access your camera.")
      }
    },
    async capturePhoto() {
      try {
        this.processing = true
        const video = this.$refs.video
        const canvas = document.createElement('canvas')
        canvas.width = 1920
        canvas.height = video.videoHeight / (video.videoWidth / 1920)
        const context = canvas.getContext('2d')
        context.drawImage(video, 0, 0, canvas.width, canvas.height)

        const blob = await new Promise((resolve) =>
          canvas.toBlob(resolve, 'image/jpeg'),
        )
        const formData = new FormData()
        formData.append('file', blob, 'photo.jpg')
        const response = await fetch('/ocr/get-text', {
          method: 'POST',
          body: formData,
        })
        const result = await response.json()
        this.updateStore(result.ocr)
        this.$router.go(-1)
      } catch (error) {
        this.showError('Error capturing photo: ' + error.message)
      }
    },
    updateStore(ocrData) {
      // Reset both stores before filling with OCR data to avoid contamination
      this.$store.dispatch('resetInputs')
      this.$store.dispatch('resetInputs2')
      
      // Fill with fresh OCR data
      this.$store.dispatch('updateInputs', { ...ocrData.OD })
      this.$store.dispatch('updateInputs2', { ...ocrData.OS })
    },
    showError(message) {
      this.snackbarMessage = message
      this.snackbar = true
    },
    closeSnackbar() {
      this.snackbar = false
      this.$router.go(-1)
    },
  },
  watch: {
    snackbar(newVal) {
      if (!newVal) {
        this.$router.go(-1)
      }
    },
  },
}
</script>
